import { createSlice } from '@reduxjs/toolkit'
import { getPersonFullName } from '../../../util/getPersonName'
import { initialStoreState } from '../../initialState'

const personsSlice = createSlice({
  name: 'persons',
  initialState: initialStoreState.persons,
  reducers: {
    personsSet: (state, action) => {
      return action.payload
    },
    personAdded: (state, action) => {
      action.payload.full_name = getPersonFullName(action.payload)
      state.push(action.payload)
    },
    personUpdated: (state, action) => {
      return state.map((item, index) => {
        if (item.person_id !== action.payload.person_id) {
          // This isn't the item we care about - keep it as-is
          return item
        }

        // Otherwise, this is the one we want - return an updated value
        return {
          ...item,
          ...action.payload,
        }
      })
    },
    personRemoved: (state, action) => {
      return state.filter((person) => person.person_id !== action.payload)
    },
  },
})

export const { personsSet, personAdded, personUpdated, personRemoved } =
  personsSlice.actions

export default personsSlice.reducer